import React from "react";
import { connect } from "react-redux";

import { Link, st } from "lib/index";

export default class AffiliateListTable extends React.PureComponent {
  render() {
    const { orders, start, end } = this.props;
    const itemDate = (order) => (
      <div className="item-date">
        {order.stock_end_datetime && (
          <div className="useby-date">
            <div className="useby-date-start">{moment.parseZone(order.stock_start_datetime).format("D MMM")}</div>
          </div>
        )}
      </div>
    );

    const headers = (
      <tr>
        <th className="center aligned">{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p6")}</th>
        <th className="center aligned">{I18n.humanAttributeName("order", "receptionist")}</th>
        <th className="center aligned">{I18n.humanAttributeName("order", "product")}</th>
        <th className="center aligned">{I18n.humanAttributeName("order", "id")}</th>
        <th className="center aligned">{I18n.humanAttributeName("order", "total_amount")}</th>
        <th className="center aligned">{I18n.humanAttributeName("order", "affiliate_commision")}</th>
      </tr>
    );
    return (
      <div className="u-overflowXAuto">
        <table className="ui table celled clear unstackable">
          <thead>{headers}</thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id}>
                <td>{itemDate(o)}</td>

                <td>{o.assigned_creator_full_name}</td>
                <td>{o.product_name}</td>
                <td>{o.id}</td>
                <td>{st.formatMoney(o.total_amount_sum)}</td>
                <td>{o.affiliate_commision_amount ? st.formatMoney(o.affiliate_commision_amount) : "-"}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            {headers}
            <tr>
              <th colSpan="2">
                {I18n.t("papp.affiliate.AffiliateListView.summary_row", {
                  start,
                  end,
                })}
              </th>
              <th />
              <th />
              <th>{st.formatMoney(st.MoneySum.sum(...orders.map((o) => o.total_amount_sum))) || "-"}</th>
              <th>
                {st.formatMoney(
                  st.MoneySum.sum(
                    ...orders.map((o) => (o.affiliate_commision_amount ? [o.affiliate_commision_amount] : []))
                  )
                ) || "-"}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/affiliate/AffiliateListView/AffiliateListTable.jsx